export default function getCopyright() {
  //return 'Copyright &copy; 2010-2015 madai';
  return 'Copyright © 2010-2020 madai';
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/getCopyright.js
 **/